import React, { PureComponent } from 'react';
import { Button, Affix } from 'antd';

// todo next release import PeriodOrdersInfo from '../periodOrdersInfo/PeriodOrdersInfo';
// todo next releaseimport UpcomingOrdersInfo from '../upcomingOrdersInfo/UpcomingOrdersInfo';
// модальные окна с подтверждением
import {
  showConfirmPutArchive,
  showConfirmRestorefromArchive,
  // showConfirmAbortEdit,
  // showConfirmSaveEdit
} from '../../../components/common/modal/confirmModal/ConfirmModal';
// успешное модальное окно
import showSuccessModal from '../../../components/common/modal/successModal/SuccessModal';
import './RightSide.css';
import BtnArchive from '../buttons/BtnArchive';

class RightSide extends PureComponent {
  componentDidUpdate(prevProps, prevState) {
    const {
      archivingError,
      archivingStatus,
      restoringStatus,
      restoringError,
      fields,
      getVehicle,
    } = this.props;
    if (prevProps.restoringStatus !== restoringStatus) {
      switch (restoringStatus) {
        case 'success':
          showSuccessModal({
            title: 'ТС успешно восстановлено!',
            content: `ТС «, ${fields['federalSign']}» успешно восстановлено. Назначение на заказы для этого ТС доступно.`,
            className: 'vehicleSuccess',
            okText: 'Готово',
            icon: 'check',
            closable: true,
            maskClosable: true,
            centered: true,
            // onOk: () => this.setState((state, props) => ({ isArchive: false })),
            // onCancel: () => this.setState((state, props) => ({ isArchive: false })),
          });
          getVehicle(fields['vehicleId']);

          // this.props.history.push(`/vehicle_card/${fields['vehicleId']}`);
          break;
        case 'error':
          showSuccessModal({
            title: 'При восстановлении возникли ошибки!',
            content: restoringError,
            className: 'vehicleSuccess',
            okText: 'Ок',
            icon: 'check',
            closable: true,
            maskClosable: true,
            centered: true,
            // onOk: () => console.log('ok'),
            // onCancel: () => console.log('cancel'),
          });
          break;
        // this.props.history.push('/vehicles');
        default:
          break;
      }
    }
    if (prevProps.archivingStatus !== archivingStatus) {
      switch (archivingStatus) {
        case 'success':
          showSuccessModal({
            title: 'ТС успешно архивировано!',
            content: `ТС «, ${fields['federalSign']}» успешно архивировано. Назначение на заказы для этого ТС недоступно.`,
            className: 'vehicleSuccess',
            okText: 'Готово',
            icon: 'check',
            closable: true,
            maskClosable: true,
            centered: true,
            // onOk: () => this.setState((state, props) => ({ isArchive: true })),
            // onCancel: () => this.setState((state, props) => ({ isArchive: true })),
          });
          getVehicle(fields['vehicleId']);

          // this.props.history.push(`/vehicle_card/${fields['vehicleId']}`);
          break;
        case 'error':
          showSuccessModal({
            title: 'При архивировании возникли ошибки!',
            content: archivingError,
            className: 'vehicleSuccess',
            okText: 'Ок',
            icon: 'check',
            closable: true,
            maskClosable: true,
            centered: true,
            // onOk: () => console.log('ok'),
            // onCancel: () => console.log('cancel'),
          });
          break;
        // this.props.history.push('/vehicles');
        default:
          break;
      }
    }
  }

  restoreHandler = () => {
    const { restoreVehicle, fields } = this.props;
    showConfirmRestorefromArchive({
      onOk: () => {
        restoreVehicle({
          vehicle_id: fields['vehicleId'],
          vehicle_status_id: 1,
        });
      },
    });
  };

  archiveHandler = () => {
    const { archiveVehicle, fields } = this.props;
    showConfirmPutArchive({
      onOk: () => {
        archiveVehicle({
          vehicle_id: fields['vehicleId'],
          vehicle_status_id: 2,
        });
      },
    });
  };

  render() {
    const { isArchive, handlerEditVehicle, vehicleId, activeProfile } = this.props; // loadVehicleHandler,
    return (
      <Affix target={() => document.getElementById('mainSheet')} offsetTop={16}>
        <div className="rightSideWrapper">
          {!isArchive && (
            <Button
              type="default"
              className="editVehicleBtn"
              onClick={handlerEditVehicle}
              disabled={
                !(activeProfile.roleKey === 'administrator' ||
                activeProfile.roleKey === 'financier' ||
                activeProfile.roleKey === 'manager' ||
                activeProfile.roleKey === 'dispatcher')
              }
            >
              Редактировать ТС
            </Button>
          )}
          <BtnArchive isArchive={isArchive} vehicleId={vehicleId} disabled={
                !(activeProfile.roleKey === 'administrator' ||
                activeProfile.roleKey === 'financier' ||
                activeProfile.roleKey === 'manager' ||
                activeProfile.roleKey === 'dispatcher')
              } />
        </div>
      </Affix>
    );
  }
}

export default RightSide;
